import { isLtIE11 } from '@/utils'
import trackService from '@/service/track'

function getTemplate() {
  if (isLtIE11()) {
    return `
    <div
      class="video"
      id="video"
      style="width:100%"
    >
      <embed type="application/x-shockwave-flash" align="middle" :height="height" :width="width" :src="playUrl" :flashvars="flashvars" allowscriptaccess="always" quality="high" allowfullscreeninteractive="true" wmode="transparent">
    </div>`
  } else {
    return `
    <div
      class="video"
      id="video"
      style="width:100%"
    >
      <video-js
        v-pre
        id="video_player"
        controls="true"
        x5-playsinline="true"
        playsinline="true"
      >
      </video-js>
    </div>`
  }
}
let tmpl = getTemplate()

export default {
  props: {
    videoInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    width: [String, Number],
    height: [String, Number],
    autoplay: {
      type: [String, Boolean],
      default: undefined
    },
    noAd: {
      type: [Boolean],
      default: undefined
    },
  },
  data() {
    return {
      playerInstance: null,
      flashvars: 'm16=1',
      playUrl: `//v.17173.com/live/playerVideo/PreloaderFileCustomer.swf&url='${window.ued.videoInfo.playUrl}'`,
      watchedTime: 0, //用户实际观看时长，单位秒
      trackTimer: null, //用于跟踪用户播放行为的定时器
      countTimer: null, //用于记录用户实际观看时长的定时器
    }
  },
  watch: {
    videoInfo() {
      let self = this
      if (isLtIE11()) {
        if (typeof self.autoplay !== 'undefined' && !self.autoplay) {
          // 不需要自动播放时改变playUrl
          let key = /([^/]+)\.html$/gi.exec(self.videoInfo.shareURL)[1]
          self.playUrl = `//f.v.17173cdn.com/player_f2/${key}.swf`
          self.flashvars = ``
        }
        if (typeof self.noAd !== 'undefined' && self.noAd) {
          self.flashvars = `${self.flashvars}&m10=0&m11=0`
        }
      } else {
        self.playerInitialize()
      }
    }
  },
  methods: {
    playerInitialize() {
      let self = this
      let options = {
        el: 'video_player',
        ...self.videoInfo, 
        ...self.videoInfo.playInfo,
        width: self.width,
        height: self.height,
        autoplay : typeof self.autoplay === 'undefined' ? 'any' : self.autoplay,
        noAd: typeof self.noAd === 'undefined' ? self.videoInfo.playInfo.noAd : self.noAd
      }
      options.poster= options.coverURL;
      let VPlayer = window.VPlayer
      // 广告没有或者已结束
      let realEnded = options.noAd || !options.beforeAd.length
      self.playerInstance = new VPlayer({
        ...options,
        on: {
          adEnd: () => {
            realEnded = true
          },
          ended: () => {
            if (!realEnded) return

            self.$emit('ended')
            self.clearTimer()
          },
          play: () => {
            if (!realEnded) return

            self.trackPlay()
            // 延迟一秒开始计时，为了与播放器自身的播放时长同步
            setTimeout(function() {
              self.setTimer()
            }, 1000)
          },
          pause: () => {
            if (!realEnded) return

            self.clearTimer()
          }
        }
      })      
    },
    triggerPlay() {
      this.playerInstance.player.play()
    },
    triggerPause() {
      this.playerInstance.player.pause()
    },
    trackPlay() {
      trackService(3, {
        playedTime: Math.ceil(this.playerInstance.player.currentTime())
      })
    },
    trackByTimer() {
      trackService(4, {
        realTime: this.watchedTime,
        playedTime: Math.ceil(this.playerInstance.player.currentTime())
      })
    },
    setTimer() {
      let self = this
      self.countTimer = setInterval(function() {
        self.watchedTime += 1
      }, 1000)
      self.trackTimer = setInterval(function() {
        self.trackByTimer()
      }, 5000)
    },
    clearTimer() {
      clearInterval(this.countTimer)
      clearInterval(this.trackTimer)
    },
  },
  template: tmpl
}
